import store from '../../../store';

export default class BaseStore {

    module = [''];

    commit(action, payload) {
        store.commit(this.namespacedModule(action), payload);
    }


    getters(property) {
        return store.getters[this.namespacedModule(property)];
    }

    state(property) {
        let temp = store.state;
        for(let i in this.module) {
            temp = temp[this.module[i]];
        }
        return temp[property];
    }

    namespacedModule(key) {
        return this.module.join('/') + '/' + key;
    }
}
